module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "menu-header"
    }
  }, [_c('div', {
    staticClass: "container-fluid header",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("../assets/img/logo-white.svg"),
      "id": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('router-link', {
    staticClass: "d-md-block d-sm-none",
    attrs: {
      "to": "/seja-um-parceiro/acesso"
    }
  }, [_vm._v("\n                    Acesso Parceiro\n                    "), _c('icon', {
    staticStyle: {
      "margin-bottom": "-8px"
    },
    attrs: {
      "name": "user-circle-o",
      "scale": "2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.3)",
      "padding": "0"
    }
  }, [_c('menu-header')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-198cf2a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/partials/Header.vue
// module id = 868
// module chunks = 0